// assets
import { ApiOutlined, BookOutlined, DashboardOutlined, LockOutlined, ReadOutlined, SafetyOutlined, TeamOutlined } from '@ant-design/icons';

// icons
const icons = {
  ApiOutlined,
  BookOutlined,
  LockOutlined,
  DashboardOutlined,
  ReadOutlined,
  SafetyOutlined,
  TeamOutlined
};

// ==============================|| MENU ITEMS - ADMINISTRATION ||============================== //

const admin = {
  id: 'group-admin',
  title: 'Administration',
  type: 'group',
  children: [
    {
      id: 'admin-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/admin',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      // /admin is a prefix of /admin/students — without this, both nav
      // items highlight at once on the Students page.
      exact: true
    },
    {
      id: 'admin-courses',
      title: 'Courses',
      type: 'item',
      url: '/admin/courses',
      icon: icons.BookOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-students',
      title: 'Students',
      type: 'item',
      url: '/admin/students',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    }
    // Organizations is hidden until there's a reason for it. The page, the API
    // and its tests are all intact, and /admin/organizations still works if you
    // go there directly — restore this entry to bring it back:
    //
    //   { id: 'admin-organizations', title: 'Organizations', type: 'item',
    //     url: '/admin/organizations', icon: icons.BankOutlined, breadcrumbs: false }
    //
    // It currently only labels a student with their client company, which
    // fills the Organization column in the progress export. The thing that
    // would justify it — reporting grouped or filtered by company — isn't
    // built, and Patrick hasn't asked for it.
  ]
};

const settings = {
  id: 'group-settings',
  title: 'Settings',
  type: 'group',
  children: [
    {
      id: 'admin-access',
      title: 'Access',
      type: 'item',
      url: '/admin/settings/access',
      icon: icons.LockOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-integrations',
      title: 'Integrations',
      type: 'item',
      url: '/admin/settings/integrations',
      icon: icons.ApiOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-administrators',
      title: 'Administrators',
      type: 'item',
      url: '/admin/settings/administrators',
      icon: icons.SafetyOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-instructors',
      title: 'Instructors',
      type: 'item',
      url: '/admin/settings/instructors',
      icon: icons.ReadOutlined,
      breadcrumbs: false
    }
  ]
};

export { settings };
export default admin;
